import React from 'react';

import Tag from '../shared/Tag';

const DisplaySelectMany = ({ values }) => {
    return (
        <div className='tag-container'>
            {values.map((item) => (
                <Tag key={item.id ?? 'NULL'} label={item.name} />
            ))}
        </div>
    );
};

export default DisplaySelectMany;
